import React from "react";
import { useTranslation } from "react-i18next";

import { PickupRequestPriority, PickupRequestReason } from "../../types";
import { isOtherReasonRequired } from "../PickupRequestDialog/modules/reasons";
import resolveReasonNames from "../../helpers/reasons";

import PriorityIcon from "../PriorityIcon";
import RequestDataRow from "../RequestDataRow";

import styles from "./RequestReasonPriority.module.scss";

interface Props {
  priority: PickupRequestPriority;
  priorityReason: string | null;
  reasonIds: number[];
  otherReasonText: string | null;
  reasons: PickupRequestReason[];
  editable?: boolean;
  /** Priority is portal-only; the participant apps show the reason without it. */
  showPriority?: boolean;
  /** Reasons are portal-only on the collector surface. */
  showReasons?: boolean;
}

const RequestReasonPriority = (props: Props) => {
  const {
    priority,
    priorityReason,
    reasonIds,
    otherReasonText,
    reasons,
    editable,
    showPriority = true,
    showReasons = true,
  } = props;
  const { t } = useTranslation();

  const reasonNames = resolveReasonNames(
    reasonIds,
    reasons,
    t("pickupRequests.details.reasonUnknown")
  );
  const showOtherReasonText =
    !!otherReasonText && isOtherReasonRequired(reasonIds, reasons);

  return (
    <div className={styles.block} data-editable={editable}>
      {showReasons && (
        <RequestDataRow label={t("pickupRequests.createDialog.reasonsLabel")}>
          {reasonNames.length
            ? `${reasonNames.join(", ")}${
                showOtherReasonText ? ` (${otherReasonText})` : ""
              }`
            : "-"}
        </RequestDataRow>
      )}

      {showPriority && (
        <RequestDataRow label={t("pickupRequests.form.priorityLabel")}>
          {t(`pickupRequests.priorities.${priority}`)}
          <PriorityIcon priority={priority} />
        </RequestDataRow>
      )}

      {showPriority && priorityReason && (
        <RequestDataRow label={t("pickupRequests.form.priorityReasonLabel")}>
          {priorityReason}
        </RequestDataRow>
      )}
    </div>
  );
};

export default RequestReasonPriority;
